import React, { useCallback } from 'react';
import Favorite from './index';
import { FAVORITE_SYSTEM } from './util';

type FavoriteSurveyItemProps = {
  response?: fhir.QuestionnaireResponse;
  item: Pick<fhir.QuestionnaireResponseItem, 'linkId'>;
  onFavoriteUpdate?: (resource: fhir.QuestionnaireResponse) => void;
};

const FavoriteSurveyItem = (props: FavoriteSurveyItemProps) => {
  const { response, item, onFavoriteUpdate } = props;

  const removeFavoriteFromItem = useCallback(
    (r: fhir.DomainResource) => {
      const resource = r as fhir.QuestionnaireResponse;

      const updateItem = (rItem: fhir.QuestionnaireResponseItem) => {
        if (rItem.linkId === item.linkId) {
          rItem.extension = (rItem.extension || []).filter(
            e => e.url !== FAVORITE_SYSTEM,
          );
        }

        if (rItem.extension?.length === 0) {
          delete rItem.extension;
        }

        if (rItem.item) {
          rItem.item = rItem.item.map(updateItem);
        }

        return rItem;
      };

      resource.item = resource.item?.map(updateItem);

      return resource;
    },
    [item],
  );

  const addFavoriteToItem = useCallback(
    (r: fhir.DomainResource) => {
      const resource = r as fhir.QuestionnaireResponse;

      const updateItem = (rItem: fhir.QuestionnaireResponseItem) => {
        if (rItem.linkId === item.linkId) {
          rItem.extension = (rItem.extension || [])
            .filter(e => e.url === FAVORITE_SYSTEM)
            .concat({ url: FAVORITE_SYSTEM });
        }

        if (rItem.item) {
          rItem.item = rItem.item.map(updateItem);
        }

        return rItem;
      };

      resource.item = resource.item?.map(updateItem);

      return resource;
    },
    [item],
  );

  const isFavorite = useCallback(
    (r: fhir.DomainResource) => {
      const resource = r as fhir.QuestionnaireResponse;

      const isFavorite = (rItem: fhir.QuestionnaireResponseItem) =>
        (rItem.linkId === item.linkId &&
          rItem?.extension?.some(e => e.url === FAVORITE_SYSTEM)) ||
        rItem.item?.some(isFavorite);

      return !!resource.item?.some(isFavorite);
    },
    [item],
  );

  return (
    <Favorite
      key={`${response?.id}-${item.linkId}`}
      resource={response || {}}
      disabled={!response}
      onFavoriteUpdate={r =>
        onFavoriteUpdate?.(r as fhir.QuestionnaireResponse)
      }
      isFavorite={isFavorite}
      addFavorite={addFavoriteToItem}
      removeFavorite={removeFavoriteFromItem}
    />
  );
};

export default React.memo(FavoriteSurveyItem);
